export const CLAROPAY_OPEN_ACCOUNT =
  "https://claropay.sng.link/Airav/iadw/hj8k";
export const CLAROPAY_PESO_X_MEGA_TERMS =
  "https://landing.claropay.com/peso-x-mega/";

export const PROMOTIONS_LINK_ES =
  "https://s3.us-west-1.amazonaws.com/sendola.io/sendolapay/Tabla+de+Promociones-+Claro+Pay.pdf";
export const PROMOTIONS_LINK_EN =
  "https://s3.us-west-1.amazonaws.com/sendola.io/sendolapay/Tabla+de+Promociones-+Claro+Pay+(English).pdf";

export const CLAROPAY_INVITE_TEXT =
  "🚀 Ya me puedes mandar dinero desde EE.UU. a mi cuenta Claro Pay con Sendola. Es seguro y me dan Megas en mi 📱 Telcel. Visita";
export const CLAROPAY_INVITE_TEXT_SENDER =
  "¡Abre tu cuenta Claro Pay y aprovecha todos los beneficios que tiene para ti!";
